import { SpriteConstant } from 'src/app/constant/sprite.constant';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class MobileHeaderLayoutComponent implements OnInit, OnChanges {
  @Output() stateValue: EventEmitter<string> = new EventEmitter<string>();
  @Input() currentLanguage = 'en';
  @Input() brownarrow;

  public state;

  lang_icons: any;
  menu_icons: any;

  constructor() {
    this.menu_icons = SpriteConstant.MENU_ICONS;
  }

  ngOnInit() {}

  ngOnChanges(data) {
    if (data.currentLanguage) {
      this.currentLanguage = data.currentLanguage.currentValue;
      this.lang_icons = SpriteConstant.LANG_ICONS(this.currentLanguage);
    }
  }

  onHeaderMenuCloseIconClick = (e) => {
    this.state = 'leave';
    this.stateValue.emit(this.state);
  };
}
